import GetFromShuffled from '../utils/GetFromShuffled';

export default GetFromShuffled([
  `agoraphobic`,
  `alcoholic`,
  `bored`,
  `closeted`,
  `depressed`,
  `desperate`,
  `dissatisfied`,
  `doomed`,
  `drug-addled`,
  `exuberant`,
  `faithless`,
  `god-fearing`,
  `hopelessly romantic`,
  `hyper-sexual`,
  `institutionalized`,
  `jilted`,
  `kilt-wearing`,
  `lovesick`,
  `maladjusted`,
  `misanthropic`,
  `morally compromised`,
  `normcore`,
  `overbearing`,
  `philosophical`,
  `precocious`,
  `quixotic`,
  `refugee`,
  `screwball`,
  `unlucky`,
  `vengeful`,
  `wealthy`,
  `young`,
])
